import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Pages.css';

const TermsOfService = () => {
  return (
    <div className="App">
      <div className="background-gradient"></div>
      <div className="noise-overlay"></div>
      <div className="grid-overlay"></div>
      <Navbar />
      <div className="page-navigation">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
      <main>
        <section className="page-section">
          <div className="page-container">
            <h1 className="page-title">Terms of Service</h1>
            <div className="page-content">
              <p className="effective-date">Effective Date: May 1, 2025</p>
              
              <div className="policy-section">
                <h2>1. Acceptance of Terms</h2>
                <p>
                  Welcome to StoryCape. These Terms of Service ("Terms") govern your access to and use of the StoryCape website, SDK, and services (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms and our Privacy Policy.
                </p>
                <p>
                  If you are using our Services on behalf of a company or other legal entity, you represent that you have the authority to bind such entity to these Terms. If you do not have such authority or do not agree with these Terms, you must not accept these Terms and may not use the Services.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>2. Changes to Terms</h2>
                <p>
                  We may modify these Terms at any time. If we make changes, we will provide notice of such changes, such as by sending an email notification, providing notice through our Services, or updating the date at the top of these Terms. Unless we say otherwise, modifications will be effective upon posting. If you continue to use our Services after we provide notice of modifications, you agree to be bound by the modified Terms.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>3. Account Registration</h2>
                <p>
                  To use certain features of our Services, you may be required to register for an account. When you register, you agree to provide accurate, current, and complete information about yourself and to keep this information updated. You are responsible for safeguarding your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>4. License and Restrictions</h2>
                <h3>4.1 License</h3>
                <p>
                  Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and use our Services for your internal business purposes.
                </p>
                
                <h3>4.2 Restrictions</h3>
                <p>
                  You may not:
                </p>
                <ul>
                  <li>Copy, modify, or create derivative works based on our Services</li>
                  <li>Reverse engineer, decompile, disassemble, or otherwise attempt to discover the source code of our Services</li>
                  <li>Access our Services to build a similar or competitive product or service</li>
                  <li>Remove any proprietary notices or labels from our Services</li>
                  <li>Use our Services in any manner that could damage, disable, overburden, or impair our Services</li>
                  <li>Use automated means to access or use our Services</li>
                  <li>Use our Services for any illegal or unauthorized purpose</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>5. User Content</h2>
                <p>
                  Our Services may allow you to upload, submit, store, send, or receive content ("User Content"). You retain all rights in and to your User Content. By submitting User Content to our Services, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such User Content in connection with providing and promoting our Services.
                </p>
                <p>
                  You are solely responsible for your User Content and the consequences of sharing it. You represent and warrant that:
                </p>
                <ul>
                  <li>You own or have the necessary rights to use and authorize us to use your User Content</li>
                  <li>Your User Content does not violate any third party's intellectual property rights, privacy rights, publicity rights, or other rights</li>
                  <li>Your User Content complies with these Terms and all applicable laws and regulations</li>
                </ul>
              </div>
              
              <div className="policy-section">
                <h2>6. Fees and Payment</h2>
                <p>
                  You agree to pay all fees specified for our Services. All payments are non-refundable unless otherwise specified. You are responsible for all taxes associated with your use of our Services. We may change our fees at any time with notice to you.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>7. Termination</h2>
                <p>
                  We may suspend or terminate your access to our Services at any time, for any reason, without notice. You may terminate your account at any time by contacting us. Upon termination, your right to use our Services will immediately cease.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>8. Disclaimer of Warranties</h2>
                <p>
                  OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT OUR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT OUR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>9. Limitation of Liability</h2>
                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE OUR SERVICES.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>10. Indemnification</h2>
                <p>
                  You agree to indemnify, defend, and hold harmless StoryCape and its officers, directors, employees, agents, and affiliates from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that arise from or relate to your use of our Services or violation of these Terms.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>11. Governing Law</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws globally, without regard to its conflict of law provisions. Any legal action or proceeding arising out of or relating to these Terms shall be brought exclusively in the federal or state courts located.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>12. Miscellaneous</h2>
                <p>
                  These Terms constitute the entire agreement between you and StoryCape regarding our Services and supersede any prior agreements. Our failure to enforce any right or provision of these Terms will not be considered a waiver of such right or provision. If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect.
                </p>
              </div>
              
              <div className="policy-section">
                <h2>13. Contact Us</h2>
                <p>
                  If you have any questions about these Terms, please contact us at:
                </p>
                <p>
                  Email: <a href="mailto:legal@storycape.io">legal@storycape.io</a><br />
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;